import { getAsync } from '../helpers/apiRequest'
import { IBodyRequestModel } from '../models/api/IBodyRequestModel'
import { TokenExpiryWrapper } from './TokenManager'

export type IStatusQueryRequest = IBodyRequestModel

export interface IStatusQueryResponse {
  success: boolean
  message?: string
  // eslint-disable-next-line
  data?: any
}

export const StatusQuery = TokenExpiryWrapper(
  async (request: IStatusQueryRequest): Promise<IStatusQueryResponse> => {
    const url = `/status/check`
    return await getAsync(url, request)
  },
  [],
  null,
)
